/* === Mein FiND interactions === */
document.addEventListener('DOMContentLoaded', function () {
const lockedRowToggles = document.querySelectorAll('[data-find-locked-row-toggle]');
// Die komplette linke Spalte nutzt CSS position: sticky.
// Dadurch bleiben Navigation, AKTIV, optional REFILL und FRAGEN in fester Reihenfolge.
lockedRowToggles.forEach(function (button) {
button.addEventListener('click', function () {
const row = button.closest('.find-cc-goodie-row');
if (!row) return;
const expanded = row.classList.toggle('is-expanded');
button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
button.textContent = expanded ? 'SCHLIESSEN −' : 'INHALTE ANSEHEN +';
});
});
const reminderRoot = document.querySelector('[data-find-reminder]');
if (reminderRoot) {
const reminderLabel = reminderRoot.querySelector('[data-find-reminder-label]');
const reminderButtons = reminderRoot.querySelectorAll('[data-find-reminder-delay]');
const reminderStatus = reminderRoot.querySelector('[data-find-reminder-status]');
const reminderCancel = reminderRoot.querySelector('[data-find-reminder-cancel]');
const reminderCustomerId = reminderRoot.getAttribute('data-find-customer-id') || 'guest';
const reminderStorageKey = 'find-command-center-reminder:' + reminderCustomerId;
let reminderTimeoutId = null;
let reminderIntervalId = null;
function readReminder() {
try {
return JSON.parse(localStorage.getItem(reminderStorageKey));
} catch (error) {
return null;
}
}
function saveReminder(reminder) {
localStorage.setItem(reminderStorageKey, JSON.stringify(reminder));
}
function clearReminderStorage() {
localStorage.removeItem(reminderStorageKey);
}
function formatRemaining(milliseconds) {
const totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
if (totalSeconds < 60) {
return totalSeconds + ' SEK.';
}
const totalMinutes = Math.ceil(totalSeconds / 60);
if (totalMinutes < 60) {
return totalMinutes + ' MIN.';
}
const hours = Math.floor(totalMinutes / 60);
const minutes = totalMinutes % 60;
return minutes ? hours + ' STD. ' + minutes + ' MIN.' : hours + ' STD.';
}
function showReminderMessage(message) {
if ('Notification' in window && Notification.permission === 'granted') {
try {
new Notification('FiND PRIORITÄTEN-WECKER', {
body: message,
icon: (document.querySelector('.find-cc') && document.querySelector('.find-cc').getAttribute('data-find-notification-icon')) || ''
});
} catch (error) {
// Fallback below remains available.
}
}
window.alert('FiND PRIORITÄTEN-WECKER\n\n' + message);
}
function clearTimers() {
if (reminderTimeoutId) {
window.clearTimeout(reminderTimeoutId);
reminderTimeoutId = null;
}
if (reminderIntervalId) {
window.clearInterval(reminderIntervalId);
reminderIntervalId = null;
}
}
function renderReminder() {
const reminder = readReminder();
if (!reminder || !reminder.dueAt || !reminder.message) {
reminderStatus.classList.remove('is-active');
reminderStatus.textContent = 'NOCH KEIN WECKER AKTIV.';
reminderCancel.hidden = true;
return;
}
const remaining = reminder.dueAt - Date.now();
if (remaining <= 0) {
clearTimers();
clearReminderStorage();
reminderStatus.classList.remove('is-active');
reminderStatus.textContent = 'WECKER AUSGELÖST.';
reminderCancel.hidden = true;
showReminderMessage(reminder.message);
return;
}
reminderStatus.classList.add('is-active');
reminderStatus.textContent =
'AKTIV: ' + reminder.message + ' // NOCH ' + formatRemaining(remaining);
reminderCancel.hidden = false;
}
function scheduleReminder(reminder) {
clearTimers();
saveReminder(reminder);
renderReminder();
const delay = Math.max(0, reminder.dueAt - Date.now());
reminderTimeoutId = window.setTimeout(renderReminder, delay);
reminderIntervalId = window.setInterval(renderReminder, 1000);
}
async function requestNotificationPermission() {
if (!('Notification' in window)) return;
if (Notification.permission !== 'default') return;
try {
await Notification.requestPermission();
} catch (error) {
// The in-page alert remains the fallback.
}
}
reminderButtons.forEach(function (button) {
button.addEventListener('click', async function () {
const delaySeconds = Number(button.getAttribute('data-find-reminder-delay')) || 60;
const message = reminderLabel.value;
await requestNotificationPermission();
scheduleReminder({
message: message,
dueAt: Date.now() + delaySeconds * 1000
});
});
});
reminderCancel.addEventListener('click', function () {
clearTimers();
clearReminderStorage();
renderReminder();
});
const storedReminder = readReminder();
if (storedReminder && storedReminder.dueAt && storedReminder.message) {
scheduleReminder(storedReminder);
} else {
renderReminder();
}
}
const refillCoinTracks = document.querySelectorAll('[data-find-refill-coins]');
refillCoinTracks.forEach(function (track) {
const total = Math.max(0, Number.parseInt(track.getAttribute('data-total-refills') || '0', 10) || 0);
const milestones = [
{ value: 1, label: 'Start', type: 'start', symbol: '⚑' },
{ value: 3, label: 'Wallpaper', type: 'wallpaper', symbol: '▣' },
{ value: 5, label: 'Audio', type: 'audio', symbol: '≋' },
{ value: 10, label: 'Refill-Vorteil', type: 'refill', symbol: '↻' },
{ value: 20, label: 'Avatar', type: 'avatar', symbol: '◎' },
{ value: 40, label: 'System', type: 'system', symbol: 'F' }
];
const nextTarget = milestones.find(function (milestone) { return total < milestone.value; });
const nextCopy = document.querySelector('[data-find-refill-next-unlock]');
track.replaceChildren();
milestones.forEach(function (milestone, index) {
const wrap = document.createElement('div');
wrap.className = 'find-cc-refill-coin-wrap';
const coin = document.createElement('span');
const reached = total >= milestone.value;
coin.className = 'find-cc-refill-coin';
coin.dataset.coinType = milestone.type;
coin.title = milestone.label + ' bei ' + milestone.value + ' Refills';
coin.textContent = reached ? milestone.symbol : String(milestone.value);
if (reached) coin.classList.add('is-active', 'is-earned');
if (nextTarget && nextTarget.value === milestone.value) coin.classList.add('is-next');
wrap.append(coin);
track.append(wrap);
const nextMilestone = milestones[index + 1];
if (!nextMilestone) return;
const gapDots = 4;
for (let dotIndex = 1; dotIndex <= gapDots; dotIndex += 1) {
const threshold = milestone.value + ((nextMilestone.value - milestone.value) * dotIndex / (gapDots + 1));
const dot = document.createElement('span');
dot.className = 'find-cc-refill-dot';
if (total >= threshold) dot.classList.add('is-active');
track.append(dot);
}
});
if (nextCopy) {
if (!nextTarget) {
nextCopy.textContent = 'Höchster System-Status erreicht. Weitere Refills zählen weiter für künftige Drops.';
} else {
const missing = Math.max(1, nextTarget.value - total);
nextCopy.textContent = 'Nächster Unlock: ' + nextTarget.label + '-Coin in ' + missing + ' Refill' + (missing === 1 ? '.' : 's.');
}
}
});
const avatarControl = document.querySelector('[data-find-avatar-control]');
if (avatarControl) {
const avatarTrigger = avatarControl.querySelector('[data-find-avatar-trigger]');
const avatarMenu = avatarControl.querySelector('[data-find-avatar-menu]');
const avatarSelected = avatarControl.querySelector('[data-find-avatar-selected]');
const avatarSelectedSymbol = avatarControl.querySelector('[data-find-avatar-selected-symbol]');
const avatarOptions = avatarControl.querySelectorAll('[data-find-avatar-choice]');
const avatarCustom = avatarControl.querySelector('[data-find-avatar-custom]');
const avatarCustomCopy = avatarControl.querySelector('[data-find-avatar-custom-copy]');
const avatarUploadLabel = avatarControl.querySelector('[data-find-avatar-upload-label]');
const avatarUpload = avatarControl.querySelector('[data-find-avatar-upload]');
const customerId = avatarControl.getAttribute('data-find-customer-id') || 'guest';
const storageKey = 'find-command-center-avatar:' + customerId;
const symbols = {
system: 'F',
energy: '⚡',
focus: '◎',
duty: '✓',
night: '24',
recovery: '+',
};
let profileCsrfToken = '';
let avatarBackendAvailable = true;
const avatarRefillCount = Number(avatarCustom?.getAttribute('data-refill-count') || '0') || 0;
const avatarUnlockThreshold = Number(avatarCustom?.getAttribute('data-unlock-threshold') || '20') || 20;
function isCustomAvatarUnlockedNow(profileUnlocked) {
return Boolean(profileUnlocked) && avatarRefillCount >= avatarUnlockThreshold;
}
function setMenu(open) {
avatarMenu.hidden = !open;
avatarTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
}
function setCustomAvatarState(unlocked, imageUrl) {
if (!avatarCustom) return;
const effectiveUnlocked = isCustomAvatarUnlockedNow(unlocked);
const missingRefills = Math.max(0, avatarUnlockThreshold - avatarRefillCount);
avatarCustom.setAttribute('data-custom-avatar-unlocked', effectiveUnlocked ? 'true' : 'false');
if (avatarCustomCopy) {
if (effectiveUnlocked) {
avatarCustomCopy.textContent = 'Freigeschaltet. Du kannst ein eigenes Bild als Avatar nutzen.';
} else if (missingRefills > 0) {
avatarCustomCopy.textContent = 'Freischaltung ab 20 Refill-Coins. Noch ' + missingRefills + ' bis zum Upload.';
} else {
avatarCustomCopy.textContent = '20 Refill-Coins erreicht. Freischaltung wird vorbereitet.';
}
}
if (avatarUploadLabel) {
avatarUploadLabel.hidden = !effectiveUnlocked;
avatarUploadLabel.setAttribute('aria-disabled', effectiveUnlocked ? 'false' : 'true');
}
if (imageUrl && effectiveUnlocked) {
applyCustomAvatar(imageUrl);
}
}
function applyCustomAvatar(imageUrl) {
avatarOptions.forEach(function (option) {
option.classList.remove('is-selected');
});
avatarSelected.className = 'find-cc-avatar-coin find-cc-avatar-coin--custom';
avatarSelected.innerHTML = '';
const img = document.createElement('img');
img.className = 'find-cc-avatar-image';
img.src = imageUrl;
img.alt = 'Kundenavatar';
avatarSelected.append(img);
}
function applyAvatar(choice, symbol) {
const safeChoice = symbols[choice] ? choice : 'system';
const safeSymbol = symbol || symbols[safeChoice] || 'F';
avatarOptions.forEach(function (option) {
option.classList.toggle(
'is-selected',
option.getAttribute('data-find-avatar-choice') === safeChoice
);
});
avatarSelected.className =
'find-cc-avatar-coin find-cc-avatar-coin--' + safeChoice;
avatarSelected.innerHTML = '<span data-find-avatar-selected-symbol></span>';
avatarSelected.querySelector('[data-find-avatar-selected-symbol]').textContent = safeSymbol;
}
async function avatarApi(action, options = {}) {
const response = await fetch(
'/apps/find-system?action=' + encodeURIComponent(action),
{
method: options.method || 'GET',
credentials: 'same-origin',
cache: 'no-store',
headers: options.body instanceof FormData
? { Accept: 'application/json' }
: {
Accept: 'application/json',
...(options.body ? { 'Content-Type': 'application/json' } : {}),
},
...(options.body
? { body: options.body instanceof FormData ? options.body : JSON.stringify(options.body) }
: {}),
}
);
const raw = await response.text();
let payload;
try {
payload = JSON.parse(raw);
} catch {
throw new Error('Avatar-Profil konnte nicht verarbeitet werden.');
}
if (!response.ok || payload.ok !== true) {
throw new Error(payload.error || 'Avatar-Profil konnte nicht gespeichert werden.');
}
return payload;
}
async function loadAvatarProfile() {
try {
const payload = await avatarApi('customer-profile');
const profile = payload.customer_profile || {};
profileCsrfToken = payload.csrf_token || profileCsrfToken;
avatarBackendAvailable = true;
if (profile.avatar_type === 'custom_image' && profile.avatar_image_url) {
applyCustomAvatar(profile.avatar_image_url);
} else {
applyAvatar(profile.avatar_coin || 'system', symbols[profile.avatar_coin] || 'F');
}
setCustomAvatarState(Boolean(profile.custom_avatar_unlocked), profile.avatar_type === 'custom_image' ? profile.avatar_image_url : '');
localStorage.setItem(
storageKey,
JSON.stringify({ choice: profile.avatar_coin || 'system', symbol: symbols[profile.avatar_coin] || 'F' })
);
} catch (error) {
avatarBackendAvailable = false;
setCustomAvatarState(false, '');
}
}
async function saveAvatarCoin(choice, symbol) {
localStorage.setItem(
storageKey,
JSON.stringify({ choice: choice, symbol: symbol })
);
if (!avatarBackendAvailable) return;
try {
if (!profileCsrfToken) {
const payload = await avatarApi('customer-profile');
profileCsrfToken = payload.csrf_token || '';
}
await avatarApi('update-customer-profile', {
method: 'POST',
body: {
csrf_token: profileCsrfToken,
avatar_type: 'coin',
avatar_coin: choice,
},
});
} catch (error) {
avatarBackendAvailable = false;
}
}
avatarTrigger.addEventListener('click', function () {
setMenu(avatarMenu.hidden);
});
avatarOptions.forEach(function (option) {
option.addEventListener('click', function () {
const choice = option.getAttribute('data-find-avatar-choice') || 'system';
const symbol = option.getAttribute('data-symbol') || symbols[choice] || 'F';
applyAvatar(choice, symbol);
saveAvatarCoin(choice, symbol);
setMenu(false);
});
});
if (avatarUpload) {
avatarUpload.addEventListener('change', async function () {
const file = avatarUpload.files && avatarUpload.files[0];
if (!file || !avatarBackendAvailable) return;
if (!isCustomAvatarUnlockedNow(true)) {
window.alert('Eigenes Avatarbild ist erst ab 20 Refill-Coins freigeschaltet.');
avatarUpload.value = '';
return;
}
try {
if (!profileCsrfToken) {
const payload = await avatarApi('customer-profile');
profileCsrfToken = payload.csrf_token || '';
}
const formData = new FormData();
formData.append('csrf_token', profileCsrfToken);
formData.append('avatar_image', file);
const payload = await avatarApi('upload-customer-avatar', {
method: 'POST',
body: formData,
});
const profile = payload.customer_profile || {};
if (profile.avatar_image_url) {
applyCustomAvatar(profile.avatar_image_url);
}
} catch (error) {
window.alert(error.message || 'Avatarbild konnte nicht hochgeladen werden.');
} finally {
avatarUpload.value = '';
}
});
}
document.addEventListener('click', function (event) {
if (!avatarControl.contains(event.target)) {
setMenu(false);
}
});
document.addEventListener('keydown', function (event) {
if (event.key === 'Escape') {
setMenu(false);
}
});
try {
const storedAvatar = JSON.parse(localStorage.getItem(storageKey));
if (storedAvatar && storedAvatar.choice) {
applyAvatar(storedAvatar.choice, storedAvatar.symbol);
} else {
applyAvatar('system', 'F');
}
} catch (error) {
applyAvatar('system', 'F');
}
loadAvatarProfile();
}
});

;
/* === Page body marker === */
document.body.classList.add('find-cc-page');

;
/* === Audio controls === */
  document.addEventListener('DOMContentLoaded', function () {
    var audioTriggers = document.querySelectorAll('[data-find-audio-trigger]');

    audioTriggers.forEach(function (trigger) {
      var wrapper = trigger.closest('.find-cc-audio-action');
      if (!wrapper) return;

      var audio = wrapper.querySelector('[data-find-audio]');
      if (!audio) return;

      trigger.addEventListener('click', function (event) {
        event.preventDefault();

        document.querySelectorAll('[data-find-audio]').forEach(function (otherAudio) {
          if (otherAudio !== audio) {
            otherAudio.pause();

            var otherWrapper = otherAudio.closest('.find-cc-audio-action');
            var otherTrigger = otherWrapper ? otherWrapper.querySelector('[data-find-audio-trigger]') : null;

            if (otherTrigger) {
              otherTrigger.textContent = otherTrigger.getAttribute('data-default-text') || 'ANHÖREN';
            }
          }
        });

        if (audio.paused) {
          audio.play();
          trigger.textContent = 'PAUSIEREN';
        } else {
          audio.pause();
          trigger.textContent = 'WEITERHÖREN';
        }
      });

      audio.addEventListener('ended', function () {
        audio.currentTime = 0;
        trigger.textContent = trigger.getAttribute('data-default-text') || 'ANHÖREN';
      });
    });
  });

;
/* === Downloads and bottom navigation === */
  document.addEventListener('DOMContentLoaded', function () {
    var downloadLinks = document.querySelectorAll(
      'a.find-cc-goodie-action[href*="cdn.shopify.com/s/files/"]'
    );

    downloadLinks.forEach(function (link) {
      if (link.hasAttribute('data-find-audio-trigger')) return;

      link.removeAttribute('target');
      link.setAttribute('rel', 'noopener');

      link.addEventListener('click', async function (event) {
        event.preventDefault();

        var fileUrl = link.getAttribute('href');
        if (!fileUrl) return;

        var cleanUrl = fileUrl.split('?')[0];
        var fileName = cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);

        try {
          link.classList.add('is-downloading');

          var response = await fetch(fileUrl);
          if (!response.ok) throw new Error('Download konnte nicht geladen werden.');

          var blob = await response.blob();
          var blobUrl = window.URL.createObjectURL(blob);

          var temporaryLink = document.createElement('a');
          temporaryLink.href = blobUrl;
          temporaryLink.download = fileName;
          document.body.appendChild(temporaryLink);
          temporaryLink.click();

          document.body.removeChild(temporaryLink);
          window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
          window.location.href = fileUrl;
        } finally {
          link.classList.remove('is-downloading');
        }
      });
    });
  });
  /* FiND PWA Bottom Nav Active State */
(function () {
  const bottomNav = document.querySelector('.find-cc-app-bottom-nav');
  if (!bottomNav) return;

  const links = Array.from(bottomNav.querySelectorAll('a[href^="#"]'));
  const sections = links
    .map((link) => {
      const id = link.getAttribute('href');
      return {
        link,
        section: document.querySelector(id)
      };
    })
    .filter((item) => item.section);

  if (!sections.length) return;

  function setActive() {
    let activeItem = sections[0];

    sections.forEach((item) => {
      const rect = item.section.getBoundingClientRect();
      if (rect.top <= 170) {
        activeItem = item;
      }
    });

    links.forEach((link) => link.classList.remove('is-active'));
    activeItem.link.classList.add('is-active');
  }

  window.addEventListener('scroll', setActive, { passive: true });
  window.addEventListener('resize', setActive);
  setActive();
})();


;
/* === Sichtbare FiND-Terminologie absichern === */
(function () {
  const replacements = [
    [/\bFiND[\s-]*Bausteine\b/gi, 'FiND Units'],
    [/\bFiND[\s-]*Baustein\b/gi, 'FiND Unit'],
    [/\bBasis[\s-]*Bausteine\b/gi, 'FiND Units'],
    [/\bSystembausteine\b/gi, 'FiND Units'],
    [/\bSystembaustein\b/gi, 'FiND Unit'],
    [/\bBausteine\b/gi, 'FiND Units'],
    [/\bBaustein\b/gi, 'FiND Unit'],
    [/\bDigitale Systemtools\b/gi, 'FiND Tools'],
    [/\bSystemtools\b/gi, 'FiND Tools'],
    [/\bModule\b/gi, 'FiND Units'],
    [/\bModul\b/gi, 'FiND Unit'],
    [/\bCommand Center\b/gi, 'Mein FiND'],
  ];

  function normalizeText(value) {
    return replacements.reduce(function (result, entry) {
      return result.replace(entry[0], entry[1]);
    }, value);
  }

  function normalizeNode(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      const nextValue = normalizeText(root.nodeValue || '');
      if (nextValue !== root.nodeValue) root.nodeValue = nextValue;
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let current;
    while ((current = walker.nextNode())) nodes.push(current);

    nodes.forEach(function (node) {
      const nextValue = normalizeText(node.nodeValue || '');
      if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
    });

    if (root.nodeType === Node.ELEMENT_NODE) {
      ['aria-label', 'title'].forEach(function (attribute) {
        if (!root.hasAttribute(attribute)) return;
        const value = root.getAttribute(attribute) || '';
        const nextValue = normalizeText(value);
        if (nextValue !== value) root.setAttribute(attribute, nextValue);
      });
    }
  }

  function startTerminologyGuard() {
    normalizeNode(document.body);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          normalizeNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(normalizeNode);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startTerminologyGuard, { once: true });
  } else {
    startTerminologyGuard();
  }
})();
